module.exports = "/_next/static/files/e78cf4c77891e475c0ea15ceeb173df3.png";